import { render, staticRenderFns } from "./pancake.vue?vue&type=template&id=617aba37&scoped=true"
import script from "./pancake.vue?vue&type=script&lang=js"
export * from "./pancake.vue?vue&type=script&lang=js"
import style0 from "./pancake.vue?vue&type=style&index=0&id=617aba37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617aba37",
  null
  
)

export default component.exports